import { Box, Dialog, DialogContent, DialogTitle, Typography } from "@material-ui/core"
import { MyDialog } from "../../components/Dialog"
import ButtonWithLoading from "../../components/ButtonWithLoading"
import ExpandCircleLoading from "../../components/expandCircle"
import { getTranslation } from "../../heplers/translationHelper";

export const AlertDialog=({open,onClose})=>{
    return (
      <MyDialog
        open={open}
        title={getTranslation("Alert")}
        onClose={onClose}
        headerStyle={{ backgroundColor: "#004467" }}
      >
        <DialogContent>
          <br />
          <br />
          <ExpandCircleLoading />
          <Typography> {open}</Typography>
          <br />
          <br />
          <Box display="flex" justifyContent="center">
            <ButtonWithLoading
              color="primary"
              title={getTranslation("Ok")}
              variant="contained"
              textColor="white"
              onClick={()=>onClose()}
            />
          </Box>
        </DialogContent>
      </MyDialog>
    );
}